import React, { useEffect, useState } from 'react';
import BBITable from '../../../../helpers/bBITable/BBITable';
import DateOnlyFormatter from '../../../../helpers/inputs/DateOnlyFormatter';
import PostForm from '../../../../api/internal/PostForm';
import Select from '../../../../assets/essentials/Select';
import Input from '../../../../assets/essentials/Input';
import Button from '../../../../assets/essentials/Button';
import classes from '../../../../assets/Global.module.css';
import Form from '../../../../assets/essentials/Form';
import Accordion from '../../../../helpers/accordion/Accordion';
import Get from '../../../../api/internal/Get';
import OptionList from '../../../../helpers/options/OptionList';
import TextArea from '../../../../assets/essentials/TextArea';

interface EndorsementsProps {
  data: Endorsement[];
  employeeId: number;
  RefreshPage: Function;
}

function Endorsements({ data, employeeId, RefreshPage }: EndorsementsProps) {
  const formattedData = data?.map(endorsement => ({
    ...endorsement,
    startDate: DateOnlyFormatter(endorsement.startDate),
    endDate: DateOnlyFormatter(endorsement.endDate),
  }));

  const columnConfig = [
    {
      key: '1',
      attribute: 'name',
      header: 'Name',
    },
    {
      key: '2',
      attribute: 'startDate',
      header: 'Start Date',
    },
    {
      key: '3',
      attribute: 'endDate',
      header: 'End Date',
    },
    {
      key: '4',
      attribute: 'note',
      header: 'Note',
    },
  ];

  function CreateEndorsement({ employeeId, RefreshPage }) {
    const [endorsementTypes, setEndorsementTypes] = useState([]);

    useEffect(() => {
      Get(`/Employee/GetEndorsementOptions`).then(response => {
        if (response) {
          setEndorsementTypes(response.data);
        }
      });
    }, []);

    function CreateDriverMaintenanceEntry(e) {
      e.preventDefault();
      const formData = new FormData(e.target);
      PostForm(`/Employee/CreateDriverEndorsement`, formData, {
        employeeId: employeeId,
      }).then(() => RefreshPage('Endorse', ['Endorse', 'Summary']));
    }

    return (
      <Accordion title={<h3>Add Endorsement</h3>}>
        <Form
          onSubmit={e => CreateDriverMaintenanceEntry(e)}
          className={classes.viewGrid}
        >
          <div className={`${classes.attribute} ${classes.span3}`}>
            <label htmlFor="endorsementId">
              Endorsement Type <span className={classes.required}>*</span>
            </label>
            <Select defaultValue="" required name="endorsementId">
              <option disabled value="">
                -- Required --
              </option>
              <OptionList
                optionData={endorsementTypes}
                attributeID={'endorsementId'}
                attributeName={'name'}
              />
            </Select>
          </div>
          <div className={`${classes.attribute}`}>
            <label htmlFor='startDate'>
              Start Date
            </label>
            <Input name="startDate" type="date" />
          </div>
          <div className={`${classes.attribute} ${classes.span2}`}>
            <label htmlFor='endDate'>
              End Date
            </label>
            <Input name="endDate" type="date"  />
          </div>
          <div className={`${classes.attribute} ${classes.span3}`}>
            <label htmlFor='note'>Note</label>
            <TextArea name="note" type="text" />
          </div>
          <div>
            <Button type="submit" variant="good">
              Submit
            </Button>
          </div>
        </Form>
      </Accordion>
    );
  }

  return (
    <>
      <CreateEndorsement RefreshPage={RefreshPage} employeeId={employeeId} />
      <BBITable data={formattedData} columns={columnConfig} />
    </>
  );
}
export default Endorsements;
